import { safeJsonParse } from "../utils/shared";

export const ACCESS_TOKEN_KEY = "accessToken";
export const REFRESH_TOKEN_KEY = "refreshToken";
export const SELECTED_TENANT_ID = "selected_tenant_id";


export const getLocalStorageItem = (key, parse = true) => {
  const item = localStorage.getItem(key);
  return parse ? safeJsonParse(item) : item;
};

export const setLocalStorageItem = (key, data) =>
  localStorage.setItem(key, JSON.stringify(data));

export const removeLocalStorageItem = (key) => localStorage.removeItem(key);
